import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import translationsEN from "./en/en.json";
import mainAr from "./ar/main.json";
import errorAr from "./ar/error.json";
import datagridAr from "./ar/datagrid.json";
import datagridEn from "./en/datagrid.json";
import AiSupportAr from "./ar/aiSupport.json";
import AiSupportEn from "./en/aiSupport.json";
import AiSupportAdminAr from "./ar/aiSupportAdmin.json";
import AiSupportAdminEn from "./en/aiSupportAdmin.json";
import { I18N_LANGUAGES } from "src/constants";

import PublicLocalizationsArabic from "src/services/public/i18n/ar.json";
import PublicLocalizationsEnglish from "src/services/public/i18n/en.json";
import AuthLocalizationsArabic from "src/services/auth/i18n/ar.json";
import AuthLocalizationsEnglish from "src/services/auth/i18n/en.json";

const resources = {
  [I18N_LANGUAGES.en]: {
    main: translationsEN,
    public: PublicLocalizationsEnglish,
    auth: AuthLocalizationsEnglish,
    datagrid: datagridEn,
    aiSupport: AiSupportEn,
    aiSupportAdmin: AiSupportAdminEn,
  },
  [I18N_LANGUAGES.ar]: {
    main: mainAr,
    Error: errorAr,
    datagrid: datagridAr,
    public: PublicLocalizationsArabic,
    auth: AuthLocalizationsArabic,
    aiSupport: AiSupportAr,
    aiSupportAdmin: AiSupportAdminAr,
  },
};

const currentLang = localStorage.getItem("i18nextLng")
i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    lng: currentLang ? currentLang : I18N_LANGUAGES.ar, // default language
    // ns: ['main', 'error'],
    defaultNS: 'main',
    fallbackLng: I18N_LANGUAGES.en,
    // keySeparator: false,
    debug: false, //$__DEV__,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
